import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, doc, onSnapshot, getDoc, setDoc } from "firebase/firestore";

const firebaseConfig = {
apiKey: "AIzaSyDBekIRhibDsheOZqt5xXJ0uWnUePlwAiU",
authDomain: "pokerly-e83aa.firebaseapp.com",
projectId: "pokerly-e83aa",
storageBucket: "pokerly-e83aa.firebasestorage.app",
messagingSenderId: "211139519904",
appId: "1:211139519904:web:aafe0f30b0bce4e22070c5",
measurementId: "G-RECT68SWG3"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export {
  db,
  collection,
  addDoc,
  doc,
  onSnapshot,
  getDoc,
  setDoc
};
export default db;
